import {
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  styled,
  Typography,
} from "@mui/material";

const StyledRadio = styled(Radio)({
  "&.Mui-checked": {
    color: "#2CABF9",
  },
  padding: 0,
  marginRight: 5,
});

export function RadioButtons({ value, onChange, options }) {
  return (
    <FormControl>
      <RadioGroup
        value={value}
        onChange={(e) => onChange(e.target.value)}
        sx={{
          "& .MuiFormControlLabel-root": {
            mb: 1,
            ml: 0,
            p: 0,
          },
          "& .MuiSvgIcon-root": {
            fontSize: 18,
          },
        }}
      >
        {options.map((opt) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={
              <StyledRadio
                size="small"
                sx={{
                  color: value === "" ? "#636363" : "#63636366",
                }}
              />
            }
            disableTypography
            label={
              <Typography
                fontSize="14px"
                fontWeight={500}
                lineHeight={1.5}
                color={
                  value === ""
                    ? "#636363"
                    : value === opt.value
                    ? "#2CABF9"
                    : "#63636366"
                }
              >
                {opt.label}
              </Typography>
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
}
